import ListViewCtrl from "../util/ListViewCtrl";

export default class OdberneMiestoListCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "OdberneMiestoService"];
  constructor(itemSource, OdberneMiestoService){
    super(itemSource);
    this.OdberneMiestoService = OdberneMiestoService;
  }

  exportXlsRk(){
    this.OdberneMiestoService.exportRk();
  }


}


// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoListCtrl.js